<template>
  <!-- 我的笔记 -->
  <div class="download">
    <Category @handle-category="handleCategoryChange" :category="category" />
    <PublicList text="笔记" :category="category" :list="downloadList" :onMoreLoad="onMoreReadList" :isShow="isShow" />
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import { getNotedDocuments } from '@/api/note.js'
import Category from './category.vue'
import PublicList from './publicList.vue'
export default {
  components: {
    Category,
    PublicList
  },
  data () {
    return {
      downloadList: [],
      isShow: true,
      category: parseInt(sessionStorage.getItem('noteCategory')) || 0,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      loading: false
    }
  },
  methods: {
    showLoading () {
      this.loading = Loading.service({
        lock: true,
        text: '正在加载，请耐心等待...'
      })
    },
    // 加载更多
    onMoreReadList () {
      this.showLoading()
      this.page.pageNum++
      this.getNotedDocuments()
    },
    handleCategoryChange (category) {
      this.showLoading()
      this.category = category
      sessionStorage.setItem('noteCategory', category)
      this.page = {
        pageNum: 1,
        pageSize: 10
      }
      this.downloadList = []
      this.getNotedDocuments()
    },
    // 还原驼峰
    setkey (arr) {
      return arr.map(item => {
        const keyArr = Object.keys(item).map(item => (item.split('_').map(item => (item.charAt(0).toUpperCase() + item.slice(1)))).join('')).map(item => (item.charAt(0).toLowerCase() + item.slice(1)))
        const valArr = Object.values(item)
        const obj = {}
        keyArr.forEach((item, i) => {
          obj[item] = valArr[i]
        })
        return obj
      })
    },
    // 获取用户下载
    async getNotedDocuments () {
      let arr = []
      try {
        const res = await getNotedDocuments({ ...this.page, category: this.category })
        const fetchedCount = res.data.reduce((sum, day) => sum + (day.subList ? day.subList.length : 0), 0)
        this.isShow = fetchedCount < this.page.pageSize
        arr = [...this.downloadList, ...res.data]
        this.downloadList = arr.map(item => ({
          subList: [{ ...item }],
          noteCount: item.noteCount
        }))
      } catch (error) {
        this.$message.error(error)
      } finally {
        if (this.loading) this.loading.close()
      }
    }
  },
  created () {
    this.getNotedDocuments()
  }
}
</script>
<style lang="less" scoped>
.download {
  min-height: 630px;
  padding-top: 1px;
  .row:first-of-type{
    padding-top: 8px;
  }
}
.el-alert {
  position: relative;
  background-color: #f5f7fb;
  padding: 0 10px;
  /deep/.el-alert__title {
    font-size: 14px;
  }
}

</style>
